const ticketSort = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_TICKET_SORT':
            return action.ticketSort
        default:
            return state
    }
}

export default ticketSort
